import { useState } from 'react';
import { siteFaqs } from '@/mocks/faq';

export default function FaqSection() {
  const [openId, setOpenId] = useState<string | null>(null);

  const toggle = (id: string) => {
    setOpenId(openId === id ? null : id);
  };

  return (
    <section className="py-10 md:py-14 px-4 md:px-6 bg-background-100" aria-labelledby="faq-heading">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-8">
          <h2 id="faq-heading" className="text-xl md:text-2xl font-heading text-foreground-950">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500 mt-1">关于韩漫屋，你想知道的都在这里</p>
        </div>

        <div className="space-y-3">
          {siteFaqs.map((faq) => (
            <div
              key={faq.id}
              className="bg-background-50 border border-background-200/70 rounded-lg overflow-hidden"
            >
              <button
                onClick={() => toggle(faq.id)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-50/80 transition-colors duration-200"
                aria-expanded={openId === faq.id}
              >
                <h3 className="text-sm md:text-base font-medium text-foreground-900 pr-4">
                  {faq.question}
                </h3>
                <i
                  className={`ri-arrow-down-s-line text-foreground-400 transition-transform duration-300 flex-shrink-0 ${
                    openId === faq.id ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              {openId === faq.id && (
                <div className="px-5 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: siteFaqs.map((faq) => ({
              '@type': 'Question',
              name: faq.question,
              acceptedAnswer: {
                '@type': 'Answer',
                text: faq.answer,
              },
            })),
          }),
        }}
      />
    </section>
  );
}